import FAQApi from "../api/FAQApi";

export function getFAQ() {
  return FAQApi.getFAQ()
}